<template>
  <footer id="footer-scc">
    <div id="main-footer" v-if="siteCustomizationData.headerFooter.showFooter">
      <div class="copyright-block" v-if="siteCustomizationData.headerFooter.showCopyright">
        <span class="item-icon"><font-awesome-icon :icon="['far', 'copyright']"/></span>
        <span class="item-year">{{ copyrightYear }}</span>
        <span>{{ copyright }}</span>
      </div>
    </div>
  </footer>
</template>

<script>
import {mapState} from 'vuex';
import moment from 'moment-timezone';

export default {
  name: "footer-css",
  computed: {
    copyrightYear: () => moment().format('YYYY'),
    ...mapState({
      copyright: state => state.settingsAndCustomize.siteCustomizationData.headerFooter.copyright,
      siteCustomizationData: state => state.settingsAndCustomize.siteCustomizationData,
    }),
  },
  mounted() {
    if (this.siteCustomizationData.headerFooter.showFooter) {
      this.customStyle()
    }
  },
  methods: {
    customStyle() {
      document.getElementById("footer-scc").style.setProperty("--FooterBackgroundColor", this.siteCustomizationData.headerFooter.footerBackgroundColor);
      document.getElementById("footer-scc").style.setProperty("--FooterFontColor", this.siteCustomizationData.headerFooter.footerFontColor);
    },
  }
}
</script>

<style scoped>
#footer-scc {
  --FooterBackgroundColor: #FFF;
  --FooterFontColor: #000;
}

#main-footer {
  background-color: var(--FooterBackgroundColor);
  color: var(--FooterFontColor);
  min-height: 50px;
}

.copyright-block {
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 80px;
  font-weight: normal;
  font-size: 12px;
}

.item-year {
  margin-right: 10px;
}

.item-icon {
  margin-right: 5px;
}
</style>
